import { Box, Stack, Typography, useTheme } from '@mui/material';
import { Info } from 'lucide-react';
import React from 'react';

interface SurveyHeaderTextProps {
  headerText?: string | null;
}

export const SurveyHeaderText: React.FC<SurveyHeaderTextProps> = ({ headerText }) => {
  const { palette } = useTheme();

  if (!headerText) {
    return null;
  }

  return (
    <Stack direction="row" gap={1} alignItems="flex-start" mb={2}>
      <Box width={20}>
        <Info size={20} color={palette.text.secondary} />
      </Box>
      <Typography variant="body1">{headerText}</Typography>
    </Stack>
  );
};
